import angular from 'angular';
import moment from 'moment';

angular
  .module('cloudX')
  .controller('MollieDirectDebitDialogCtrl', [
    '$http',
    'appUrls',
    'flySvc',
    '$filter',
    '$q',
    '$element',
    'dataCache',
    'close',
    'relationId',
    mollieDirectDebitDialogCtrl,
  ]);

function mollieDirectDebitDialogCtrl(
  $http,
  appUrls,
  flySvc,
  $filter,
  $q,
  $element,
  dataCache,
  close,
  relationId,
) {
  var vm = this;
  vm.saving = false;
  vm.loading = true;
  vm.iban = undefined;
  vm.option = 1;
  vm.loading = true;
  $q.all([
    $http
      .get(`${appUrls.api}/api/relation/DirectDebitAccount?id=${relationId}`)
      .then(({ data }) => data),
  ]).then(
    function([iban]) {
      vm.iban = iban;
      vm.loading = false;
    },
    error => {
      flySvc.error(error);
      vm.loading = false;
    },
  );

  vm.save = function() {
    if (vm.saving || !vm.iban) return '';

    vm.saving = true;

    $http
      .post(`${appUrls.api}/api/relation/MollieCreateMandate?id=${relationId}&iban=${vm.iban}`)
      .then(
        function(result) {
          flySvc.success('msgMandateCreatedInMollie');
          $element.modal('hide');
          close(null, 500);
        },
        error => {
          flySvc.error(error);
          vm.saving = false;
        },
      );
  };

  vm.cancel = function() {
    $element.modal('hide');
    close(null, 500);
  };
}
